export default {
    LIST: 'list',
    SELECTED_KEYWORDS: 'keyword(s)',
};
